module.exports = __webpack_public_path__ + "img/ic_next_single.6e2e9878.svg";